<template>
  <v-row justify="center">
    <v-dialog
      v-bind:value="value"
      v-on:input="$emit('input', $event.target.value)"
      persistent
      max-width="400px"
    >
      <v-card>
        <v-card-title>
          <b>New API Key</b>
        </v-card-title>
        <v-card-text>
          <div class="d-flex" v-if="loading">
            <v-skeleton-loader
              type="list-item"
              width="100%"
              class="mt-auto mb-auto"
            >
            </v-skeleton-loader>
            <v-skeleton-loader type="button" class="mt-auto mb-auto">
            </v-skeleton-loader>
          </div>
          <div v-else>
            <p>
              Please copy this API key, you will not be able to see the full key
              again.
            </p>
            <div class="mt-5 d-flex">
              <v-text-field
                class="mt-auto mb-auto"
                outlined=""
                hide-details=""
                single-line=""
                dense=""
                readonly=""
                ref="apikeytext"
                v-model="apikey"
              ></v-text-field>
              <!-- <v-btn icon="" class="mt-auto mb-auto ml-3" @click="copy">
                <v-icon>mdi-clipboard-text-outline</v-icon>
              </v-btn> -->
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="grey" text @click="$emit('input', false)">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="blue"
            @click="$emit('input', false)"
            :disabled="loading"
            min-width="100px"
            depressed
            :loading="loading"
            class="white--text"
            >Finish</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import services from "@/services/index";
export default {
  props: ["value"],
  data: () => ({
    loading: true,
    apikey: ""
  }),
  methods: {
    copy() {
      /* Get the text field */
      var copyText = this.$refs.apikeytext;
      /* Select the text field */
      copyText.select();
      copyText.setSelectionRange(0, 99999); /*For mobile devices*/

      /* Copy the text inside the text field */
      document.execCommand("copy");
    },
    async createKey() {
      this.loading = true;
      try {
        const apikey = await services.apikeys.create();
        this.apikey = apikey;
        this.loading = false;
      } catch (err) {
        console.error("KEY ERROR", err);
        this.error = true;
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    value() {
      if (this.value == true) {
        this.createKey();
      } else {
        this.apikey = "";
      }
    }
  },
  mounted() {
    if (this.value === true) {
      this.createKey();
    }
  }
};
</script>

<style></style>
